import maplibregl from 'maplibre-gl';
import { Protocol } from 'pmtiles';

import sources from './style/style.sources.json';
import layers from './style/style.layers.json';

const protocol = new Protocol();
maplibregl.addProtocol('pmtiles', protocol.tile);

/*  Exports
    ======================================================================================= */
/**
 * @param {maplibregl.Map} maplibreMap 
 * @returns {maplibregl.Map}
 */
function addSourcesAndLayersFromConfigToMap(maplibreMap) {
  maplibreMap.addSource('satellite-source', {
    type: 'raster',
    tiles: ['https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}.png'],
    tileSize: 256,
    attribution: '<a target="_blank" href="http://www.esri.com/" class="esri-attribution__link">Esri</a>',
  });

  maplibreMap.addLayer({
    id: 'satellite',
    type: 'raster',
    source: 'satellite-source',
    layout: {
      visibility: 'none',
    },
    paint: {},
  }, 'River labels');

  maplibreMap.addSource('boundaries-regions', {
    type: 'geojson',
    data: '/malawi_regions.geojson',
    promoteId: 'shapeName',
  });

  maplibreMap.addLayer({
    source: 'boundaries-regions',
    id: 'malawi-regions-fill',
    type: 'fill',
    paint: {
      'fill-color': [
        'case',
        ['boolean', ['feature-state', 'selected'], false], '#4CAF50',
        '#CEE8D1',
      ],
      'fill-opacity': 0.5,
    },
  }, 'River labels');

  maplibreMap.addLayer({
    source: 'boundaries-regions',
    id: 'kasungu-outline',
    type: 'line',
    filter: ['==', ['get', 'shapeName'], 'Kasungu'],
    paint: {
      'line-color': '#6E6E6E',
    },
  }, 'River labels');

  maplibreMap.addLayer({
    source: 'boundaries-regions',
    id: 'malawi-regions-outline',
    type: 'line',
    paint: {
      'line-color': '#D4D4D4',
    },
  }, 'kasungu-outline');

  maplibreMap.addSource('baseline-wind-speed', {
    type: 'image',
    url: '/100yr_wind_speeds_baseline.png',
    coordinates: [
      [10.05, -5.15],
      [135.05, -5.15],
      [135.05, -60.15],
      [10.05, -60.15],
    ],
  });

  maplibreMap.addLayer({
    id: 'baseline-wind-speed-layer',
    type: 'raster',
    source: 'baseline-wind-speed',
    paint: { 'raster-opacity': 0.6 },
    layout: { visibility: 'none' },
  }, 'malawi-regions-outline');

  maplibreMap.addSource('future-wind-speed', {
    type: 'image',
    url: '/100yr_wind_speeds_future.png',
    coordinates: [
      [10, -5.1],
      [135, -5.1],
      [135, -60.1],
      [10, -60.1],
    ],
  });

  maplibreMap.addLayer({
    id: 'future-wind-speed-layer',
    type: 'raster',
    source: 'future-wind-speed',
    paint: { 'raster-opacity': 0.6 },
    layout: { visibility: 'none' },
  }, 'malawi-regions-outline');

  Object.keys(sources).forEach(sourceId => maplibreMap.addSource(sourceId, sources[sourceId]));
  layers.forEach(layer => maplibreMap.addLayer(layer));

  return maplibreMap;
}

function mapFactory(mapEl, initialBounds = undefined) {
  const options = {
    container: mapEl,
    attributionControl: false,
    style: `https://api.maptiler.com/maps/0198cd0d-152c-7df0-b467-fc64803317b3/style.json?key=${import.meta.env.VITE_MAPTILER_TOKEN}`,
    center: [33.480264, -13.039146],
    zoom: 8,
    fadeDuration: 0,
  };

  const map = new maplibregl.Map(options);

  if (initialBounds) {
    map.fitBounds(initialBounds, { padding: 20 });
  }

  return map;
}

export {
  mapFactory,
  addSourcesAndLayersFromConfigToMap,
}